import React, { useState } from "react";
import { useSelector } from "react-redux";
import PersianDatePicker from "./NewRangePicker";
import moment from "moment-jalaali";

const RangePickerEvents = ({ dateHOC, setDatesHOC }) => {
  const lang_choiced = useSelector((state) => state.lang_change);

  const [date, setDate] = useState(dateHOC);

  const handleRangeChange = (selectedDates) => {
    if (!selectedDates || selectedDates.length !== 2) return;

    setDate(selectedDates);

    // const start = moment(selectedDates[0], "jYYYY-jMM-jDD").startOf("day").toDate();
    // const end = moment(selectedDates[1], "jYYYY-jMM-jDD").endOf("day").toDate();

    // console.log(start.toISOString(), end.toISOString());

    // فرستادن به parent
    setDatesHOC(selectedDates);
  };

  return (
    <PersianDatePicker
      dateHOC={date}
      onRangeChange={handleRangeChange}
    />
  );
};

export default React.memo(RangePickerEvents);
